import { defineComponent as _defineComponent } from 'vue';
import FormDisplay from "@/components/Form/FormDisplay.vue";
import FormCard from "@/components/Form/FormCard.vue";
import FormElement from "@/components/Form/FormElement.vue";
import FormOutputLabel from "@/components/Workflow/Editor/Forms/FormOutputLabel.vue";
import FormConditional from "./FormConditional.vue";
import WorkflowIcons from "@/components/Workflow/icons";
import { useWorkflowStepStore } from "@/stores/workflowStepStore";
import { useUniqueLabelError } from "../composables/useUniqueLabelError";
import { computed, toRef } from "vue";
import { useStepProps } from "../composables/useStepProps";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormDefault',
    props: {
        step: null,
        datatypes: null
    },
    emits: ["onAnnotation", "onLabel", "onAttemptRefactor", "onEditSubworkflow", "onSetData"],
    setup(__props, { emit }) {
        const props = __props;
        const stepRef = toRef(props, "step");
        const { stepId, contentId, annotation, label, name, type, configForm } = useStepProps(stepRef);
        const stepStore = useWorkflowStepStore();
        const uniqueErrorLabel = useUniqueLabelError(stepStore, label.value);
        const stepTitle = computed(() => {
            if (label.value) {
                return label.value;
            }
            if (isSubworkflow.value) {
                return name.value;
            }
            else {
                return (contentId === null || contentId === void 0 ? void 0 : contentId.value) || name.value;
            }
        });
        const nodeIcon = computed(() => WorkflowIcons[type.value]);
        const formDisplayId = computed(() => stepId.value.toString());
        const isSubworkflow = computed(() => type.value === "subworkflow");
        function onAnnotation(newAnnotation) {
            emit("onAnnotation", stepId.value, newAnnotation);
        }
        function onLabel(newLabel) {
            emit("onLabel", stepId.value, newLabel);
        }
        function onEditSubworkflow() {
            emit("onEditSubworkflow", contentId.value);
        }
        function onUpgradeSubworkflow() {
            emit("onAttemptRefactor", [{ action_type: "upgrade_subworkflow", step: { order_index: stepId.value } }]);
        }
        function onChange(values) {
            emit("onSetData", stepId.value, {
                id: stepId.value,
                type: type.value,
                content_id: contentId.value,
                inputs: values,
            });
        }
        return { __sfc: true, props, emit, stepRef, stepId, contentId, annotation, label, name, type, configForm, stepStore, uniqueErrorLabel, stepTitle, nodeIcon, formDisplayId, isSubworkflow, onAnnotation, onLabel, onEditSubworkflow, onUpgradeSubworkflow, onChange, FormDisplay, FormCard, FormElement, FormOutputLabel, FormConditional };
    }
});
